

/* ⚛ REACT */
import {  useRef, useState } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button } from "../../../../Components";

/* 📁 ASSETS */
import { Back, ArrowLeft, ArrowRight } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { CalendarContainer, BackIcon, ButtonContainer } from "./styles";

/* 🔗 SERVICE */
import { ControlePerdasService } from "../../../../Services/dashboardServices/controlePerdas";


import { store } from "../../../../Redux/Store";

import { ChangeLossControlDay, ChangeLossControlMonth, changeModal, ChangeLossControlyear} from "../../../../Redux/Actions";

/* 🔧 UTILS */
import { getDataString } from "../../../../util/Months";


const CalendarMonth = ({ container, selectedDate }) => {
  const { t } = useTranslation();

  const controlePerdasService = useRef(new ControlePerdasService());
  // Meses vindos do i18next
  const months = t(
    "dashboards.sub-items.loss-control.months",
    { returnObjects: true }
  );

  const [currentDate, setCurrentDate] = useState(selectedDate ?? new Date());

  const selectedMonth = currentDate.getMonth();
  const year = currentDate.getFullYear();

  const updateDate = (month, year) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(month);
    newDate.setFullYear(year);
    setCurrentDate(newDate);
  };

  const handleSelectMonth = (index) => {
    updateDate(index, year);
  };

  const handlePrevYear = () => {
    updateDate(selectedMonth, year - 1);
  };

  const handleNextYear = () => {
    updateDate(selectedMonth, year + 1);
  };

  const handleBackToday = () => {
    setCurrentDate(new Date());
  };

  return (
    <>
      <CalendarContainer $container={container}>
        <div className="header">
          <button className="arrow" onClick={handlePrevYear}>
            <BackIcon src={ArrowLeft} />
          </button>

          <span className="year-label">{year}</span>

          <button className="arrow" onClick={handleNextYear}>
            <BackIcon src={ArrowRight} />
          </button>
        </div>

        <div className="content-selected-month">
          <div className="calendar-grid">
            {months.map((month, index) => (
              <div
                key={index}
                className={`month-cell ${
                  selectedMonth === index ? "selected-month" : ""
                }`}
                onClick={() => handleSelectMonth(index)}
              >
                {month}
              </div>
            ))}
          </div>

          <div className="button-wrapper">
            <Button
              className='button-return'
              text={t("buttons.return")}
              color='green-blue'
              icon={<BackIcon src={Back}/>}
              onClick={handleBackToday}
            />
          </div>
        </div>
      </CalendarContainer>
      <ButtonContainer>
        <Button className='button-confirm' text={t("buttons.confirm")} width={'100px'} padding={'10px'}
        onClick={() => {
                          store.dispatch(ChangeLossControlDay(currentDate.getDate()));
                          store.dispatch(ChangeLossControlMonth(getDataString(currentDate.getMonth() + 1)));
                          store.dispatch(ChangeLossControlyear(currentDate.getFullYear()));
                          controlePerdasService.current.changeMonthYear(currentDate.getDate(), getDataString(currentDate.getMonth() + 1), currentDate.getFullYear());
                          store.dispatch(changeModal(''));
                        }}
        />  
      </ButtonContainer>
    </>
  );
};

export default CalendarMonth;
